<!-- 房源管理(整租) -->
<template>
  <el-main>
    <div class="tableList">
      <div class="search">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item><el-select v-model="formInline.cityName" placeholder="请选择城市" clearable><el-option v-for="item in cityList" :key="item.name" :label="item.name" :value="item.name"></el-option></el-select></el-form-item>
          <el-form-item><el-select v-model="formInline.regionName" placeholder="请选择区域" clearable><el-option v-for="item in regionList" :key="item.name" :label="item.name" :value="item.name"></el-option></el-select></el-form-item>
          <el-form-item><el-select v-model="formInline.priceName" placeholder="请选择价格区间" clearable><el-option v-for="item in priceList" :key="item.name" :label="item.name" :value="item.name"></el-option></el-select></el-form-item>
          <el-form-item><el-input v-model="formInline.keyWord" clearable placeholder="请输入关键字"></el-input></el-form-item>
          <el-form-item><el-button type="primary" @click="()=>{ paging.page = 1;this.getList() }" icon="el-icon-search" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}">检索</el-button></el-form-item>
          <div :style="{float:'right'}">
            <el-form-item><el-button size="small" type="primary" icon="el-icon-plus" :style="{backgroundColor: $store.state.activeColor,borderColor: $store.state.activeColor}" @click="addSchool">新建</el-button></el-form-item>
            <el-form-item><el-button size="small" type="primary" icon="el-icon-minus" :style="{backgroundColor: $store.state.deleteColor,borderColor: $store.state.deleteColor}" @click="delSchool">删除</el-button></el-form-item>
          </div>
        </el-form>
      </div>
      <div class="tableContent">
        <el-table
          @selection-change="handleSelectionChange"
          row-key="id"
          class="table"
          ref="tableData"
          :data="table.tableData"
          border
          :height="table.tableHeight"
          element-loading-text="拼命加载中,请等待"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.1)"
        >
          <el-table-column width="45" type="selection" :reserve-selection="true" align="center"></el-table-column>
          <el-table-column width="100" prop="id" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{ (paging.page-1)*paging.size+scope.$index+1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="hot" label="热门" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.hot == 1 ? true:false" @change="changeHot($event,scope.row,'hot')"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="grounding" label="上架" align="center">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.grounding == 1 ? true:false" @change="changeHot($event,scope.row,'grounding')"></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center" width="300px"></el-table-column>
          <el-table-column prop="city" label="城市" align="center" width="200px"></el-table-column>
          <el-table-column prop="no" label="房源编号" align="center" width="200px"></el-table-column>
          <el-table-column prop="facilityServices" label="设施服务" align="center" width="400px"></el-table-column>
          <el-table-column prop="facilityServicesTop" label="卖点标签" align="center" width="400px"></el-table-column>
          <el-table-column prop="regionKeyword" label="区域" align="center" width="400px"></el-table-column>
          <el-table-column prop="schoolKeyword" label="学校" align="center" width="400px"></el-table-column>
          <el-table-column prop="landmarkKeyword" label="地标" align="center" width="400px"></el-table-column>
          <el-table-column prop="houseInfo" label="房屋信息" align="center" width="400px"></el-table-column>
          <el-table-column prop="price" label="价格" align="center" width="400px"></el-table-column>
<!--          <el-table-column prop="orderinfo"  label="排序" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              <el-button type="text" icon="el-icon-bottom" :style="{color: $store.state.activeColor, padding:0, fontSize:'20px'}" @click="orderInfo('down', scope.row)"></el-button>-->
<!--              <el-button type="text" icon="el-icon-top" :style="{color: $store.state.activeColor, padding:0, fontSize:'20px'}" @click="orderInfo('up', scope.row)"></el-button>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="操作" align="center" width="180" fixed="right">
            <template slot-scope="scope">
              <el-popconfirm class="real_pop" title="您确定要复制房源信息吗？" @confirm="handleOperation('copy', scope.row)">
                <el-button slot="reference" type="text" size="mini" icon="el-icon-s-claim" :style="{color: $store.state.activeColor}">复制</el-button>
              </el-popconfirm>
              <el-button type="text" size="mini" @click="handleOperation('edit', scope.row)" icon="el-icon-edit" :style="{color: $store.state.activeColor,marginLeft:'10px'}">编辑</el-button>
              <el-popconfirm class="real_pop" title="您确定要删除房源信息吗？" @confirm="handleOperation('remove', scope.row)">
                <el-button class="danger" slot="reference" type="text" size="mini" :icon="scope.row.status ? 'el-icon-circle-check':'el-icon-circle-close'">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="tablePagination">
        <el-pagination
          class="customPagination"
          @size-change="handlePaginationChange"
          @current-change="handlePaginationCurrentChange"
          :current-page="paging.page"
          :page-sizes="[15, 25, 50]"
          :page-size="paging.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="paging.total"
        >
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
  export default {
    name: 'HousingManagementFullRent',
    data () {
      return {
        formInline: { // 查询参数
          keyWord: '' ,// 关键字
          cityName: '', // 城市
          regionName: '', // 区域
          priceName: '', // 价格
          hot: true, // 是否热门
          parentId: '', // 父id
        },
        table: { // 表格参数
          tableData:[], // 表格数据
          tableHeight: null, // 表格高度
        },
        paging: { // 分页参数
          page: 1,// 页码
          size: 15, // 条数
          total: 0, // 总数
        },
        checkIds:[], // 所选列表
        cityList:[], // 城市列表
        regionList:[], // 区域列表
        priceList:[{id:1,name:'100-500'},{id:2,name:'500-1000'},{id:3,name:'1000-1500'},{id:4,name:'1500-2000'}], // 价格列表
      }
    },
    methods: {
      // 获取表格数据
      getList(){
        this.$api.searchHouse({
          page:this.paging.page,
          size:this.paging.size,
          keyword:this.formInline.keyWord,
          cityKeyword:this.formInline.cityName,
          regionKeyword:this.formInline.regionName,
          price:this.formInline.priceName,
          hot:this.formInline.hot,
          parentId:this.formInline.parentId,
          mode: "整租"
        }).then(res => {
          if (res.data.status == 200) {
            this.table.tableData = res.data.data.records;
            this.paging.total = Number(res.data.data.total);
            if(this.table.tableData != ""){
              this.$nextTick(() => {
                this.$refs.tableData.clearSelection();
              })
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 获取城市数据
      getCityList(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        }];
        this.$api.findCity({
          page:1,
          size:this.$store.state.size,
          parameter: JSON.stringify(parameter)
        }).then(res => {
          if (res.data.status == 200) {
            this.cityList = res.data.data.records;
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 获取区域数据
      getRegionList(){
        let parameter = [{
          "field":"status",
          "fun":"ne",
          "value": "0"
        }];
        this.$api.findRegion({
          page:1,
          size:this.$store.state.size,
          parameter: JSON.stringify(parameter)
        }).then(res => {
          if (res.data.status == 200) {
            this.regionList = res.data.data.records;
            for (let i = 0; i < this.regionList.length; i++){
              this.regionList[i].disabled = false;
            }
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 分页部分改变条数
      handlePaginationChange(val) {
        this.paging.size = val;
        this.paging.page = 1;
        this.getList();
      },
      // 分页部分改变页码
      handlePaginationCurrentChange(val) {
        this.paging.page = val;
        this.getList();
      },
      // 切换选择
      handleSelectionChange(val) {
        this.checkIds = [];
        if (val.length > 0) {
          for (let i = 0; i < val.length; i++) {
            this.checkIds.push(val[i].id);
          }
        }
      },
      // 新建School
      addSchool(){
        this.$router.push({
          path:'/HousingManagementOperation',
          query:{ type:1 }
        });
      },
      // 批量删除School
      delSchool(){
        for(let i = 0 ; i < this.table.tableData.length; i++){
          for(let j = 0; j < this.checkIds.length; j++){
            if (this.checkIds[j] == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
        }
        this.setBatch('批量删除成功！');
      },
      // 批量添加修改列表
      setBatch(title){
        this.$api.saveOrUpdateHouseBatch({ parameter: JSON.stringify(this.table.tableData)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: title,
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 房源流水号
      getHouseApplyNoByNo(city,mode,apartmentNo) {
        return new Promise((resolve)=>{
          this.$api.houseApplyNo({cityName:city,mode:mode,apartmentNo:apartmentNo}).then(res => {
            if (res.data.status == 200) {
              resolve(res.data.data);
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        })
      },
      // 编辑/删除
      async handleOperation(type,row){
        if (type == "edit") {  // 编辑操作
          this.$router.push({
            path:'/HousingManagementOperation',
            query:{ data:row, type:1 }
          });
        } else if (type == "remove") { // 删除操作
          for(let i = 0 ; i < this.table.tableData.length; i++){
            if (row.id == this.table.tableData[i].id){
              this.table.tableData[i].status = 0;
            }
          }
          this.setBatch('删除成功！');
        } else if (type == "copy") { // 复制操作
          delete row.id;
          row.no = await this.getHouseApplyNoByNo(row.city,row.mode,"");
          this.$api.saveOrUpdateHouse({parameter: JSON.stringify(row)}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                type: 'success',
                message: '复制成功！'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        }
      },
      // 改变热门
      changeHot(id,data,type){
        let params = {};
        if (type == 'hot'){
          let hot = id == true ? 1 : 0;
          params = { id: data.id,hot:hot };
        } else {
          let grounding = id == true ? 1 : 0;
          params = { id: data.id,grounding:grounding };
        }
        this.$api.saveOrUpdateHouse({parameter: JSON.stringify(params)}).then(res => {
          if (res.data.status == 200) {
            this.$message({
              message: '修改成功！',
              type: 'success'
            });
            this.getList();
          } else {
            this.$message({
              type: 'error',
              message: res.data.message
            });
          }
        });
      },
      // 改变orderInfo顺序
      orderInfo(type,data){
        if (this.table.tableData.length <=1){
          this.$message({
            message: '没有足够多的数据不能改变顺序！',
            type: 'warning'
          });
          return;
        }
        if (type == "up"){
          this.$api.sortHouse({ id: data.id,sort:1}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                message: '修改成功！',
                type: 'success'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        } else {
          this.$api.sortHouse({ id: data.id,sort:-1}).then(res => {
            if (res.data.status == 200) {
              this.$message({
                message: '修改成功！',
                type: 'success'
              });
              this.getList();
            } else {
              this.$message({
                type: 'error',
                message: res.data.message
              });
            }
          });
        }
      },
      // table的高度
      getTableHeight(){
        let that = this;
        if($(".table").length > 0) {
          // 表格高度初始化事件
          $(".table").height(window.innerHeight - $(".table").offset().top - 70);
          $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
          that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
          // 窗口改变事件
          window.onresize = function () { // 定义窗口大小变更通知事件
            if($(".table").length > 0) {
              $(".table").height(window.innerHeight - $(".table").offset().top - 70);
              $(".table .el-table__empty-block").height(window.innerHeight - $(".table").offset().top - 132);
              that.table.tableHeight = window.innerHeight - $(".table").offset().top - 70;
            }
          };
        }
      },
    },
    mounted() {
      // 获取页面表格高度
      this.getTableHeight();
      // 获取列表
      this.getList();
      // 获取城市列表
      this.getCityList();
      // 获取区域列表
      this.getRegionList();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/css/detaileds.css";/* 列表样式 */
</style>





// WEBPACK FOOTER //
// src/components/Menu/HousingManagementFullRent.vue